import { createSelector } from "reselect";

export const orgIntegrationsState = (state) =>
  state.orgIntegrations.get("org_integrations", []);

export const orgIntegrationsSelector = () =>
  createSelector([orgIntegrationsState], (org_integrations) => org_integrations);